import React, { memo } from 'react';
import { pick } from 'ramda';
import Tabs, { Tab } from '../common/Tabs';
import style from './index.scss';

export const TabTitle = memo(({ title, count }) => <>{title}&nbsp;
    <span className={style.counter}>({count})</span>
</>);

export const tabsClassNames = pick(['tab', 'active'], style);

export default ({ tabs, onChange, activeTab }) => (
    <Tabs
        onChange={onChange}
        className={style.tabs}
        classNames={tabsClassNames}
        activeTab={activeTab}>
        {tabs.map(({ title, count, name }) => (
            <Tab key={name} value={name}>
                <TabTitle title={title} count={count} />
            </Tab>
        ))}
    </Tabs>
);
